import script from "./TherapyVideoItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./TherapyVideoItem.vue?vue&type=script&setup=true&lang=ts"

import "./TherapyVideoItem.vue?vue&type=style&index=0&id=10269ed6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10269ed6"]])

export default __exports__